module.exports = __webpack_public_path__ + "static/media/email_failure.ff37e96f.svg";